import * as Yup from "yup";
import { StringValidation, DropdownValidation } from "./PlanSchema";

export const OrganisationTypeSchema = Yup.object().shape({
  name: StringValidation.label("Name"),
  aspect: DropdownValidation.label("Type aspect"),
});
